import { apiClient } from '@/shared/api/http-client';

import { emailVerificationStatusSchema, passwordStatusSchema } from '../model/user.schemas';
import type {
    ChangeEmailInput,
    ChangePasswordInput,
    ConfirmIdentityInput,
    EmailVerificationStatus,
    GetUserResponse,
    PasswordStatus,
} from '../model/user.types';

export const userApi = {
    get: (signal?: AbortSignal) => apiClient.get<GetUserResponse>('/auth/user', signal),
    signOut: () => apiClient.post('/auth/sign-out', {}),
    finalizeSignIn: (signal?: AbortSignal) =>
        apiClient.post<{ ready: boolean }>('/auth/sign-in-by-token', undefined, signal),
    getPasswordStatus: async (signal?: AbortSignal): Promise<PasswordStatus> => {
        const data = await apiClient.get('/auth/password', signal);
        return passwordStatusSchema.parse(data);
    },
    changePassword: (input: ChangePasswordInput, signal?: AbortSignal) =>
        apiClient.put('/auth/password', input, signal),
    confirmIdentity: (input: ConfirmIdentityInput, signal?: AbortSignal) =>
        apiClient.post('/auth/identity-confirmation', input, signal),
    changeEmail: (input: ChangeEmailInput, signal?: AbortSignal) =>
        apiClient.put('/auth/email', input, signal),
    getEmailVerificationStatus: async (signal?: AbortSignal): Promise<EmailVerificationStatus> => {
        const data = await apiClient.get('/auth/email-verification', signal);
        return emailVerificationStatusSchema.parse(data);
    },
    resendEmailVerification: () => apiClient.post('/auth/email-verification/resend'),
};
